import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Drug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { routePaths } from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { DropDown } from '../../models/dropdown';
import { DropdownValues } from '../../models/synmed-data';
import { OpenEditWizardService } from '../../services/open-edit-wizard.service';
@Component({
    selector: 'app-import-wizard-quarantined-drug-list',
    templateUrl: './import-wizard-quarantined-drug-list.component.html',
    styleUrls: ['./import-wizard-quarantined-drug-list.component.scss'],
    standalone: false
})
export class ImportWizardQuarantinedDrugListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns = ['name', 'ndc', 'countryCode', 'qReason', 'source','system', 'strength', 'manufacturer', 'priority', 'modifiedBy' ,'requestor', 'age','action'];
  selectedRow:any;
  searchText:string;
  permanentQuarantine:boolean;
  listOfCountry :DropDown[] =[];
  listOfQReason :DropDown[] =[];
  listOfDataSourceFilter :DropDown[] =[];
  countryId:number= 0;
  qReasonId:number= 0;
  dataSourceId:number= 0;
  selectedSearchCriteria : any;
  modifiedBy: string;
  permanentQuarantineList:DropDown[]= DropdownValues.CommonBooleanDropDownValues
  dataSource= new MatTableDataSource<Drug>();
     //#region Pagination properties
     totalRows: number = 0;
     currentPage: number = 1;
     pageSize: number = 10;
     pageSizeOptions: number[] = [50, 100, 200, 500];
     //#endregion
  constructor(
    public dialogRef: MatDialogRef<ImportWizardQuarantinedDrugListComponent>,
    public dialog: MatDialog,
    private rpoService:RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    private openEditWizardService: OpenEditWizardService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.dataSourceId = data?.dataSourceId;
      this.searchText = data?.searchText;
      this.countryId = data?.countryId;
      this.qReasonId = data?.qReasonId;
      this.permanentQuarantine = data?.permanentQuarantine;
      this.selectedSearchCriteria = data?.selectedSearchCriteria;
     }

  ngOnInit(): void {
    this.getDrugData();
    this.getCountry();
    this.getDataSourceFilter();
    this.getQuarantineReasonList();
  }
  search(){
    this.getDrugData();
  }
  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getDrugData();
  }
  getDrugData(){
    let quarantinedKey = 'QuarantinedKey'
    this.ngxLoader.start(quarantinedKey);
    this.rpoService.getQuarantinedDrugata(
      this.dataSourceId,
      this.searchText,
      this.permanentQuarantine,
      this.countryId,
      this.qReasonId,
      this.currentPage == 0 ? 1 : this.currentPage,
       this.pageSize,
       this.selectedSearchCriteria,
       this.modifiedBy
    ).subscribe((response)=>{
      let result = response.data;
      this.ngxLoader.stop(quarantinedKey);
     this.dataSource.data = result.drugs
     setTimeout(() => {
      this.paginator.pageIndex = this.currentPage;
      this.paginator.length = result.totalRows;
    });
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop(quarantinedKey);
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }
  getCountry(){
    this.ngxLoader.start();
    this.rpoService.getCountry().subscribe((result)=>{
      this.ngxLoader.stop();
      this.listOfCountry = result.data;
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop();
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  getQuarantineReasonList() {
    this.ngxLoader.start();
    this.rpoService.getQuarantineReasonList().subscribe((result) => {
      this.ngxLoader.stop();

      const allQReasonData = result.data;

       if (allQReasonData.length > 1) {
        // Add 'All' key when more than one assigned...
        result.data.unshift(
          {
            "value":-1,
            "label":"All"
          }
        );
        this.qReasonId = -1;
      } else if (allQReasonData.length === 1) {
        // Otherwise, automatically select assign country if exists...
        this.qReasonId = allQReasonData[0]["value"];
      }

      this.listOfQReason = allQReasonData;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  getDataSourceFilter(){
    this.ngxLoader.start();
    this.rpoService.getDataSourceFilter().subscribe((result)=>{
      this.ngxLoader.stop();
      this.listOfDataSourceFilter = result.data;
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop();
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  openDrugDetailsImportWizard(drugId:string, dataSourceId:number) {
    
    this.openEditWizardService.openDrugDetailsImportWizard(drugId,dataSourceId,'');
  }

}
